import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SideModalDialogData } from '../interfaces/dialogs.interface';
import { ButtonMessageComponent } from './button-message/button-message.component';
import { OkMessageComponent } from './ok-message/ok-message.component';
import { SideModalComponent } from './side-modal/side-modal.component';

/**
 * Open side modal dialog
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openSideModalDialog = (dialog: MatDialog, data: SideModalDialogData): Promise<MatDialogRef<SideModalComponent>> => {
  return dialog
    .open(SideModalComponent, {
      id: 'side-modal-dialog',
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      data,
    })
    .afterClosed()
    .toPromise();
};

/**
 * Open center blocked content message
 * button content depends on the user logged in state
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openBlockedContentMessageDialog = (dialog: MatDialog, isLogged: boolean): Promise<MatDialogRef<ButtonMessageComponent>> => {
  return dialog
    .open(ButtonMessageComponent, {
      id: 'ok-message-dialog',
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      data: {
        message: 'dialog.subscriptionNeed',
        buttonMessage: isLogged ? 'dialog.ok' : 'dialog.signIn',
        buttonIcon: isLogged ? null : 'sign-in',
        customClass: isLogged ? null : 'sign-in',
      },
    })
    .afterClosed()
    .toPromise();
};

/**
 * Open center ok message modal dialog
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openNotFoundMessageDialog = (dialog: MatDialog): Promise<MatDialogRef<OkMessageComponent>> => {
  return dialog
    .open(OkMessageComponent, {
      id: 'ok-message-dialog',
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      data: {
        message: 'content.not-found-message',
      },
    })
    .afterClosed()
    .toPromise();
};
